<template>
    <div>
      <div class="popstyle" style='z-index:99;' v-bind:style="{display:parsedLocalizado}">
        <b-modal class="fixedModal" ref="ListModal" size="lg" centered :hide-footer="true" @hidden="onHidden">
          <div v-show="!hideList">
            <v-server-table
            ref="table"
            class="custom"
            :columns="columns"
            :url="url"
            :options="options">
              <div slot="id_comercial" slot-scope="props">
                {{props.row.id_comercial.id}}
              </div>
              <div slot="id_caldera" slot-scope="props">
                {{props.row.id_caldera.id}}
              </div>
              <div slot="nombre" slot-scope="props">
                {{props.row.id_comercial.nombre}}
              </div>
              <div slot="dirección" slot-scope="props">
                <span v-if="props.row['id_'+type].tipo_via && props.row['id_'+type].nombre_via && props.row['id_'+type].numero">
                  {{props.row['id_'+type].tipo_via}}
                  {{props.row['id_'+type].nombre_via}},
                  {{props.row['id_'+type].numero}}
                  {{props.row['id_'+type].anexo}},
                  {{props.row['id_'+type].poblacion}},
                  {{props.row['id_'+type].municipio}},
                  {{props.row['id_'+type].provincia}}
                </span>
                <span v-else>
                  {{props.row['id_'+type].direccion_no_estructurada}}
                </span>
              </div>
              <div slot="status" slot-scope="props">
                {{status.find(e => e.id === props.row.id_comercial.id_status_gestion_comercial).status}}
              </div>
              <div slot="visitado" slot-scope="props">
                <span v-if="props.row['id_'+type].visitas.length>0">Si</span>
                <span v-else>No</span>
              </div>
              <div slot="visitado_usuario" slot-scope="props">
                <span v-if="props.row['id_'+type].visitas.filter(e => e.codigo_visitador === user).length>0">Si</span>
                <span v-else>No</span>
              </div>
              <div slot="acciones" slot-scope="props">
                <b-btn @click="openDetails(props.row)">Ir</b-btn>
                <b-btn variant='danger' :disabled='show_only' @click="removeFromLote(props.row)">Eliminar</b-btn>
              </div>
            </v-server-table>
          </div>
          <div v-if="hideList">
            <div>
              <b-row>
                <b-col>
                  <b-btn @click="close">Atras</b-btn>
                </b-col>
                <b-col style="text-align: right;" >
                  <b-btn @click="localizar">Localizar</b-btn>
                </b-col>
              </b-row>
              <Details @close="close" @comercialSaved="comercialSaved" @calderaSaved="calderaSaved" ref="details" :feature="feature" :permisos="permisos"></Details>
            </div>
          </div>
        </b-modal>
      </div>
      <div v-if="localizado" class="bottomButton">
        <!-- <b-button v-if="change" @click="saveLocation">Guardar</b-button> -->
        <b-button @click="atras">Atras</b-button>
      </div>
    </div>
</template>

<style>
.custom table td {
  padding: unset !important;
}
.bottomButton {
  bottom: calc(15rem - 100vh);
  position: relative;
  left: 100%;
}
</style>

<script>
import Table from '@/components/Modules/Table/Table.vue';
import Details from '@/components/Modules/Map/Details.vue';

export default {
  name: 'LotesListSolapados',
  components: { Table, Details },
  props: ['idis', 'id_lote', 'tipo_lote', 'user', 'permisos', 'show_only'],
  data () {
    var data = {
      modification: null,
      layer: null,
      hideList: false,
      localizado: false,
      feature: {id_tipo_establecimiento_gn_comercial: 0},
      status: [],
      url: 'asignacion_lote_solapados/',
      options: {
        filterable: ['status', 'visitado', 'visitado_usuario'],
        filterByColumn: true,
        sortIcon: {
          base: 'fa',
          up: 'fa-caret-down',
          down: 'fa-caret-up',
          is: 'fa-sort'
        },
        requestKeys: {
          query: 'search',
          orderBy: 'ordering',
          limit: 'page_size'
        },
        sortable: ['id_comercial', 'nombre', 'id_caldera', 'status'],
        customFilters: ['id_lote', 'tipo_lote', 'idis'],
        perPage: 10,
        perPageValues: [],
        requestFunction: function (data) {
          var text = (this.$parent.$parent.tipo_lote === 'GC') ? 'comercial' : 'caldera';
          let params = Object.keys(data.search);

          for (let index = 0; index < params.length; index++) {
            const element = params[index];

            let val = data.search[element];
            if (val) {
              if (element === 'status') {
                data['id_' + text + '__id_status_gestion_' + text + '__status__iexact'] = val;
              } else if (element === 'visitado') {
                if (val === 'No') {
                  data['id_' + text + '__visitas__isnull'] = true;
                } else if (val === 'Si') {
                  data['id_' + text + '__visitas__isnull'] = false;
                }
              } else if (element === 'visitado_usuario') {
                if (val === 'Si') {
                  data['id_' + text + '__visitas__codigo_visitador__contains'] = this.$parent.$parent.user;
                } else if (val === 'No') {
                  data['not_id_' + text + '__visitas__codigo_visitador__contains'] = this.$parent.$parent.user;
                }
              } else {
                data[element] = val;
              }
            }
          }
          delete data.search;

          data.ordering = data.ordering.replace('nombre', 'id_' + text + '__nombre');
          data.ordering = data.ordering.replace('status', 'id_' + text + '__id_status_gestion_' + text + '__status');
          return this.$http.get(this.url, { params: data }).then(function (data) {
            return data.json();
          }, function (e) {
            this.dispatch('error', e);
          }.bind(this));
        },
        responseAdapter: function (resp) {
          return {
            data: resp.results,
            count: resp.count
          };
        },
        initFilters: {idis: this.idis.join(','), id_lote: this.id_lote, tipo_lote: this.tipo_lote}
      }
    };
    if (this.tipo_lote === 'GC') {
      data.columns = ['id_comercial', 'nombre', 'dirección', 'status', 'visitado', 'visitado_usuario', 'acciones'];
    } else {
      data.columns = ['id_caldera', 'dirección', 'visitado', 'visitado_usuario', 'acciones'];
    }
    return data;
  },
  mounted: function () {
    var text = (this.tipo_lote === 'GC') ? 'comercial' : 'caldera';
    console.log('A', this);
    this.$http.get('status_gestion_' + text + '/', {params: {not_paginated: true}}).then(results => {
      this.status = results.data;
      this.$refs.ListModal.show();
    });
  },
  methods: {
    atras: function () {
      this.localizado = false;
      this.$parent.$parent.$parent.map.map.removeLayer(this.$parent.$parent.$parent.selectedLayer);
    },
    close: function () {
      this.$refs.table.getData();
      this.hideList = false;
    },
    comercialSaved: function () {
      this.$parent.$parent.$parent.comercialSaved();
    },
    calderaSaved: function () {
      this.$parent.$parent.$parent.calderaSaved();
    },
    onHidden: function () {
      this.$emit('hidden');
    },
    localizar () {
      this.localizado = true;
      this.$parent.$parent.$parent.setLocation();
    },
    openDetails: function (row) {
      var text = (this.tipo_lote === 'GC') ? 'comercial' : 'caldera';
      this.getFeature(row['id_' + text].id);
    },
    removeFromLote: function (row) {
      let text = (this.tipo_lote === 'GC') ? 'comercial' : 'caldera';
      if (this.$parent.newLote.metodo_lote_selected.id === 'Manual') {
        if (confirm('¿Desea eliminar este establecimiento del lote?')) {
          this.$emit('deleteFromLote', row['id_' + text].id.toString());
        }
      } else {
        this.$emit('deleteFromParametrizadoLote', row['id_' + text].id.toString());
      }
    },
    getFeature (id) {
      var typeName = (this.tipo_lote === 'GC') ? 'geovisor:comercial' : 'geovisor:caldera';
      var params = {
        request: 'GetFeature',
        service: 'WFS',
        typeNames: typeName,
        feature_count: 100,
        version: '2.0.0',
        outputFormat: 'json',
        featureID: id
      };

      var url = process.env.URL_WFS;

      var th = this;
      self.$.ajax({
        url: url + self.L.Util.getParamString(params, url, true),
        success: function (data, status, xhr) {
          th.showDetails(data.features[0]);
        },
        error: function (xhr, status, error) {
          alert(error);
        }
      });
    },
    showDetails: function (row) {
      try {
        var type = row.id.split('.')[0];
        var id = row.id.split('.')[1];

        this.$http.get(type + '/' + id + '/').then(result => {
          row.properties = result.data;
          this.feature = row;
          this.hideList = true;
        });
        this.$parent.$parent.$parent.clickFeature(row);
      } catch (err) {
        alert(err);
      }
    }
  },
  computed: {
    type: function () {
      if (this.tipo_lote === 'CC') {
        return 'caldera';
      } else {
        return 'comercial';
      }
    },
    parsedLocalizado: function () {
      if (this.localizado) {
        return 'none';
      } else {
        return 'block';
      }
    }
  },
  watch: {
    idis: {
      handler: function (newValue) {
        this.$refs.table.customQueries.idis = this.idis.join(',');
        this.$refs.table.getData();
        // this.options.initFilters.idis = newValue
        // this.$refs.table.refresh()

        // this.applyCount()
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/LotesListSolapados.vue